import(/* webpackMode: "eager" */ "/opt/build/repo/app/pricing/page.tsx");
